(function () {
    'use strict';

    angular.module("imApp").factory("srOperationManualAddService", ['$ihttp', function ($ihttp) {
        var service = {
            getSrOperationManualAdd: function (parms) {
                return $ihttp.post({
                    method: 2140,
                    parameters: parms || {}
                });
            },
            listHrsNo: function (parms) {
                return $ihttp.post({
                    method: 2142,
                    parameters: parms || {}
                });
            },
            listResources: function (parms) {
                return $ihttp.post({
                    method: 2143,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2141,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();